import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { sendHoverSoundCommand, sendClickSoundCommand, sendCancelClickSoundCommand } from '../../helpers/web_to_client'
import { BUTTON_SMALL_TYPES } from '../../constants'

import styles from './ButtonSmall.css'

class ButtonSmall extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        type: PropTypes.oneOf(BUTTON_SMALL_TYPES),
        isCancel: PropTypes.bool,
        isPending: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isFocusOn: PropTypes.bool,
        isJustified: PropTypes.bool,
        muteClick: PropTypes.bool,
        muteHover: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
        buttonSmallRef: PropTypes.func,
        tooltipId: PropTypes.string,
        mixClassName: PropTypes.string,
        tabIndex: PropTypes.number,
    }

    static defaultProps = {
        type: 'default',
        muteClick: false,
        muteHover: false,
    }

    constructor(props) {
        super(props)

        this.handleClick = this.handleClick.bind(this)
        this.handleMouseDown = this.handleMouseDown.bind(this)
        this.refCallback = this.refCallback.bind(this)
    }

    componentDidMount() {
        if (this.props.isFocusOn) {
            this._button.focus()
        }
    }

    handleClick(e) {
        this.props.onClick(e)
    }

    handleMouseDown() {
        this.props.isCancel ? sendCancelClickSoundCommand() : sendClickSoundCommand()
    }

    refCallback(c) {
        this._button = c

        if (this.props.buttonSmallRef) {
            this.props.buttonSmallRef(c)
        }
    }

    render() {
        const classNameBase = classNames(styles.base, styles[`base__${this.props.type}`], {
            [styles.isDisabled]: this.props.isDisabled,
            [styles.isPending]: this.props.isPending,
            [styles.isJustified]: this.props.isJustified,
        }, this.props.mixClassName)

        const dataAttrs = this.props.tooltipId ? {
            'data-tip': true,
            'data-for': this.props.tooltipId,
        } : {}

        const tabIndexAttr = this.props.tabIndex !== undefined ? {
            tabIndex: this.props.tabIndex,
        } : {}

        return (
            <button
                ref={this.refCallback}
                className={classNameBase}
                onClick={this.props.isDisabled ? null : this.handleClick}
                onMouseDown={(this.props.isDisabled || this.props.muteClick) ? null : this.handleMouseDown}
                onMouseEnter={(this.props.isDisabled || this.props.muteHover) ? null : sendHoverSoundCommand}
                {...tabIndexAttr}
                {...dataAttrs}
            >
                <span className={classNames(styles.condition, styles['condition__active'])} />
                <span className={classNames(styles.condition, styles['condition__hover'])} />
                <span className={classNames(styles.condition, styles['condition__focus'])} />
                <span className={classNames(styles.condition, styles['condition__disabled'])} />
                <span className={styles.caption}>{this.props.children}</span>
            </button>
        )
    }
}

export default ButtonSmall



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/ButtonSmall/ButtonSmall.jsx